export default __webpack_public_path__ + "static/media/StudyFinance.25773e836c0290ee05d2211c6dd95d2b.webp";